module.exports = __webpack_public_path__ + "img/logo-white.7da9cc75.svg";